import { render, staticRenderFns } from "./PontoEletronicoPrincipal.vue?vue&type=template&id=1df7b147&"
import script from "./PontoEletronicoPrincipal.vue?vue&type=script&lang=js&"
export * from "./PontoEletronicoPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports